import { lazy } from 'react';

const list = lazy(() => import('pages/mailTemplate/list/List'));
const edit = lazy(() => import('pages/mailTemplate/edit/Edit'));
const create = lazy(() => import('pages/mailTemplate/create/Create'));

export { list, edit, create };
